var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import { MenuContext } from '../context/MenuContext';
const InternalSubMenuList = (_a, ref) => {
    var { className, children } = _a, restProps = __rest(_a, ["className", "children"]);
    const { prefixCls, mode } = React.useContext(MenuContext);
    return (<ul className={classNames(prefixCls, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className)} {...restProps} data-menu-list ref={ref}>
            {children}
        </ul>);
};
const SubMenuList = React.forwardRef(InternalSubMenuList);
SubMenuList.displayName = 'SubMenuList';
export default SubMenuList;
